// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"264b0f0f","455":"7b6d588d","977":"1fc686cc"}[chunkId] + ".chunk.js";
};